<template>
  <div>
    <template v-for="(param, index) in node.parameters">
      <div :key="index">
        <label class="control-label">
          {{ param.displayName }} <span v-if="!param.isOptional">*</span>
          <i
            v-tooltip.top="param.description"
            class="fa fa-question-circle m-l-5"
            aria-hidden="true"
          />
        </label>
      </div>
    </template>
    <div class="cf-node-properties__field">
      <PrismEditor
        v-model="settings.script"
        :highlight="highlighter"
        :line-mumbers="false"
        @input="inputChange"
      />
    </div>
  </div>
</template>

<script>
import messages from '../../../../locales';

import nodePropsMixin from '@/modules/ivrs/mixins/nodePropsMixin';

// import Prism Editor
import { PrismEditor } from 'vue-prism-editor';

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';

export default {
  name: 'JsNodeProps',

  components: {
    PrismEditor
  },

  mixins: [nodePropsMixin],

  watch: {
    node: {
      immediate: true,
      handler(newValue) {
        this.settings = {...newValue.settings};
      }
    }
  },
  methods: {
    highlighter(code) {
      return highlight(code, languages.js, 'js');
    }
  },

  i18n: {
    messages,
    locale: 'en',
  },
};
</script>
